





















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { processServe } from '@/api/installServer';
import shuttleOldBox from '@/components/shuttleBox/shuttleOldBox.vue';
import ShuttleChildernBox from '@/components/shuttleBox/shuttleChildernBox.vue';
import { uuid } from '@/util/uuid';
@Component({
  components: { shuttleOldBox, ShuttleChildernBox },
})
export default class FlowWorkCustom extends Vue {
  @Prop() flowData: any;
  formData: any = {
    name: 'name',
    startAuthOrgMember: [],
  };
  options: any = [];
  value: any = '';
  dataIndex: any;
  dataForm: any = [];
  flowId: any;
  choseSelfList: any = [];
  mounted() {
    console.log(uuid());
    this.getId();
    console.log(this.flowData);
    this.flowData.controlList.forEach((item: any) => {
      const obj: any = item;
      obj.props.value = '';
      this.dataForm.push(obj);
    });
    this.flowData.flowNodeList.forEach((item: any) => {
      if (item.sponsorChoose) {
        this.choseSelfList.push(item);
      }
    });
  }
  private back() {
    this.$emit('back');
  }

  getId() {
    const arr: any = this.$route.path.split('/');
    const code = arr[arr.length - 1];
    processServe
      .getIdByCode(code)
      .then((res: any) => {
        console.log(res.data);
        this.flowId = res.data;
      })
      .catch((e: any) => {});
  }

  choseSponsor(index: any) {
    const shuttleBox = 'shuttleBox';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    this.dataIndex = index;
    (shuttleBoxComponent as any).showDialog(this.dataForm[index].props.value);
  }

  choseFlowStaffSponsor(index: any) {
    const shuttleBox = 'shuttleBoxFlow';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    this.dataIndex = index;
    (shuttleBoxComponent as any).showDialog(this.choseSelfList[index].choseList);
  }

  checkNodeData(data: any) {
    console.log(data);
    this.dataForm[this.dataIndex].props.value = data;
  }

  checkNodeDataFlow(data: any) {
    console.log(data);
    // this.choseSelfList[this.dataIndex].choseList = data;
    this.$set(this.choseSelfList[this.dataIndex], 'choseList', data);
    // console.log(this.choseSelfList);
  }

  saveData() {
    console.log(this.flowData);
    console.log(this.dataForm);
    const dataMap: any = {};
    this.dataForm.forEach((item: any) => {
      if (item.componentName === 'ContactPerson') {
        const arr: any = [];
        item.props.value.forEach((staff: any) => {
          arr.push(staff.objId);
        });
        dataMap[item.props.id] = arr.toString();
      } else {
        dataMap[item.props.id] = item.props.value;
      }
    });

    const choseMap: any = {};
    this.choseSelfList.forEach((item: any) => {
      if (item.choseList) {
        if (item.sponsorChoose.info.scopeType === 'company') {
          const arr: any = [];
          item.choseList.forEach((staff: any) => {
            arr.push(staff.objId);
          });
          choseMap[item.flowNodeId] = arr.toString();
        } else {
          choseMap[item.flowNodeId] = item.choseList.toString();
        }
      }
    });

    const data: any = {
      controlValueMap: dataMap,
      flowAssignStaffIdsMap: choseMap,
    };

    processServe
      .startFlowExample(data, this.flowId)
      .then((res: any) => {
        console.log(res.data);
        if (res.code === '200') {
          this.back();
        }
      })
      .catch((e: any) => {});
  }
}
